/* 
PUBLIC PAGE 
*/
import React from "react";
import Layout from "../Components/Layout/Layout";
import BusRegisterForm from "../Components/BusRegisterForm/BusRegisterForm";

function BusRegisterPage() {
  return (
    <Layout>
      <BusRegisterForm />
    </Layout>
  );
}

export default BusRegisterPage;
